/**
 * Created by katarinababic on 14.5.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ExerciseSet } from '../../../../Model/WorkoutLog/ExerciseSet';
import {
  BaseTrackingKey,
  PlanableTrackingKey,
  TrackingKeyEntry,
  TrackingKeys,
} from '../../../../Model/ProgramPortfolio/TrackingKeys';
import { useTrans } from '../../../../Store/System/LocalizationStore';
import dayjs from 'dayjs';
import { Theme } from '../../../../Theme/Theme';

export type EndWorkoutEditResultsTrackingKeysProps = {
  set: ExerciseSet;
  trackingKey: BaseTrackingKey;
  isLast: boolean;
};

export const EndWorkoutEditResultsTrackingKeys: React.FC<EndWorkoutEditResultsTrackingKeysProps> = observer(
  ({ set, trackingKey, isLast }) => {
    const { t } = useTrans();

    const definition: TrackingKeyEntry | undefined = trackingKey ? TrackingKeys[trackingKey] : undefined;
    const tracksTime: boolean = trackingKey === 'DURATION' || trackingKey === 'BREAK';
    const minValue: number = React.useMemo(() => {
      if (set && !set.isFinished) {
        return set.values.get(trackingKey) || set.values.get(`MIN_${trackingKey}` as PlanableTrackingKey) || 0;
      }
      return (
        set.values.get(`${trackingKey}` as PlanableTrackingKey) ||
        set.values.get(`MIN_${trackingKey}` as PlanableTrackingKey) ||
        0
      );
    }, [trackingKey, set]);

    const trackingKeyUnit = React.useMemo<string | undefined>(() => {
      if (trackingKey && definition?.defaultUnit) {
        // ensure translation return is treated as string
        return (t(`trackingKeys.units.${definition.defaultUnit}`) as string) || undefined;
      }
      return undefined;
    }, [trackingKey, definition, t]);

    const minValueString: string = React.useMemo(() => {
      if (tracksTime) {
        const ms = minValue * 1000;
        if (minValue > 3599) {
          return dayjs.utc(ms).format('HH:mm:ss');
        }
        return dayjs.utc(ms).format('mm:ss');
      }
      return `${minValue}`;
    }, [tracksTime, minValue]);

    // Render the tracking value, unit, and separator icon if not last
    return (
      <React.Fragment>
        <span>
          {minValueString}
          {trackingKeyUnit ? ` ${trackingKeyUnit}` : ''}
        </span>
        {!isLast && (
          <i
            className="mdi mdi-circle-medium"
            style={{ color: Theme.Colors.warmGrey, margin: '0 4px', verticalAlign: 'middle' }}
          />
        )}
      </React.Fragment>
    );
  },
);
